/// <reference path="../../interfaces/lightsliderconfig.ts" />

interface JQuery {
    imagesLoaded: any
}

module Elma.Bindings {
    export class LightSlider {


        public init(element: HTMLElement, valueAccessor: () => LightSliderConfig, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;
            //TODO: JQUERY HACK NNO
            var ele = $(element);
            bindingContext.$data.lightSlider = ele;

            var bindSlider = (el: JQuery, settings: LightSliderConfig) => {
                let $parentElm = el.closest(".js-slider-parent");
                if ($parentElm) {
                    // try to find our custom pagination
                    let $navElm = $parentElm.find(".js-custom-pagination")
                    if ($navElm) {
                        // custom pagination exists
                        // we bind to our custom slider

                        var $controlElements = $navElm.find(".js-change-slide");

                        // adding listener to the current slider settings
                        // to ensure our custom pagination works as it should 
                        $.extend(settings, {
                            onAfterSlide: function (el) {
                                // when slide changes add active class
                                // so that pagination is always up to date with what happens

                                var currentSlideCount = el.getCurrentSlideCount() - 1; // remove one to match eq fn 

                                if (currentSlideCount) {                                    
                                    $controlElements.removeClass("active");
                                    $controlElements.eq(currentSlideCount).addClass("active");
                                }
                            }
                        });

                        var slider: any = el.lightSlider(settings);

                        $controlElements.on("click", function (e) {
                            e.preventDefault();
                            let $currentBullet = $(e.target);
                            var currentSlide: number = Number($currentBullet.attr("data-slide-count"));
                            slider.goToSlide(currentSlide);
                        });

                        if ($parentElm.find(".lSAction").is(":visible") == false) {
                            $controlElements.hide();
                        }
                        else {
                            $controlElements.show();
                        }
                    }
                    else {
                        // custom parent exists, but no pagination
                        // we load the slider regularly
                        el.lightSlider(settings); 
                    }
                }
                else {
                    // regular load the slider
                    el.lightSlider(settings); 
                }
            }

            var settings = valueAccessor() || {};

            if (ele.data("wait-for-load")) {
                // expecting data-wait-for-load='true' on the element
                // when a lot of images, lightSlider can be too slow to load
                // waiting for all other stuff to load first and then show the slider
                // so that the slider doesn't crash 

                ele.imagesLoaded().done(function loadSliderNow() {
                    ele.closest(".js-slider-parent").removeClass("visibility-hidden");
                    bindSlider(ele, settings);
                });
                
            }
            else {
                // regular load
                bindSlider(ele, settings);
            }
        }

    }
    ko.bindingHandlers['lightSlider'] = new LightSlider();
}